<template>
  <div class="personnel-grow">
    <AppBar />
    <div class="page-content">
      <div class="personnel-grow-canvas">
        <div class="personnel-grow-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
            <div class="solution-btn" @click="openBealter">预约演示</div>
          </div>
        </div>
      </div>
      <div ref="nav" class="personnel-grow-nav">
        <div ref="navTabs" class="personnel-grow-nav-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['personnel-grow-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="product-value" class="product-value">
          <div class="title-subtitle">
            <div class="title">产品价值分析</div>
            <div class="subtitle">实现培训从计划到实施的全流程线上管理模式</div>
          </div>
          <div class="value-list">
            <div
              v-for="(item, index) in valueList"
              :key="index"
              class="value-list-item"
            >
              <div class="value-list-item-card">
                <div class="list-item-icon-wrap">
                  <img
                    :src="item.icon"
                    alt=""
                    class="list-item-icon"
                  />
                </div>
                <div class="list-item-text">
                  <div class="list-item-title">
                    {{ item.title }}
                  </div>
                  <div class="list-item-des">
                    {{ item.describe }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="architecture" class="architecture">
          <div class="title">系统流程图</div>
          <div class="architecture-content">
            <img :src="architecture" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">系统功能介绍</div>
          <div class="introduction-content">
            <div
              v-for="(item, index) in introductionList"
              :key="index"
              class="introduction-content-item"
              :class="{ 'introduction-tag-item-active': index == introductionTagActiveIndex }"
              @mouseenter="changeIntroduction(index)"
            >
              <div class="introduction-tag-item-text">
                <div class="introduction-tag-item-title">{{ item.title }}</div>
                <div v-show="index == introductionTagActiveIndex" class="line"></div>
                <div v-if="index != introductionTagActiveIndex" class="introduction-tag-item-subtitle">{{ item.subtitle }}</div>
                <div v-else class="introduction-tag-item-content">
                  <div v-for="(contentItem, contentIndex) in item.ContentList" :key="contentIndex" class="content-item">
                    <img :src="require('@/assets/personnelgrow/icon/check.png')" alt="" />
                    <div>{{ contentItem }}</div>
                  </div>
                </div>
              </div>
              <div class="introduction-tag-item-img">
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-top: 60px;">
        <div style="background-color: #f7f9fc;">
          <div ref="data-security" class="data-security">
            <div class="title">数据安全</div>
            <div class="data-security-tag">
              <div v-for="(item, index) in dataSecurityTagList" :key="index" class="data-security-tag-item">
                <div class="item-box" @click="changeStep(index)">
                  <div class="item-icon" :class="{ 'item-icon-active': item.index === dataSecurityTagActiveIndex }">
                    <img :src="item.url" alt="" />
                  </div>
                  <div class="item-title">{{ item.title }}</div>
                </div>
                <div v-if="index<2" class="data-security-tag-arrow"></div>
              </div>
            </div>
            <div class="data-security-content">
              <div class="arrow" @click="last">
                <img :src="require('@/assets/personnelgrow/icon/left-arrow.png')" alt="" />
              </div>
              <transition name="secrity-fade" mode="out-in">
                <div v-if="dataSecurityList.length != 0" :key="dataSecurityTagActiveIndex" class="data-security-content-list">
                  <div class="data-security-content-left">
                    <img :src="dataSecurityList[dataSecurityTagActiveIndex].url" alt="" />
                  </div>
                  <div class="data-security-content-right">
                    <div
                      v-for="(item, index) in dataSecurityList[dataSecurityTagActiveIndex].textList"
                      :key="index"
                      class="content-text-box"
                    >
                      <img :src="require('@/assets/home/content-tip.png')" alt="" class="list-icon" />
                      <div class="text">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="arrow" @click="next">
                <img :src="require('@/assets/personnelgrow/icon/right-arrow.png')" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="customer-stories">
          <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="data-download" class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div v-for="(item, index) in dataDownloadList" :key="index" class="data-download-content-item">
              <div class="dataListTitle">{{ item.title }}</div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                  @click="clickDate(dataItem, index)"
                >
                  <div class="data-list-left">
                    <div class="disc"></div>
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                  <div class="data-list-right">
                    <img :src="require('@/assets/icon/right-arrow.png')" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="appointment-demonstration">
        <div class="content-center">
          <div class="appointment-demonstration-text">
            <h4 class="appointment-demonstration-title">了解更多有关华跃产品与服务信息</h4>
            <h5 class="appointment-demonstration-subtitle">您还可以预约我们的产品演示</h5>
          </div>
          <div class="appointment-demonstration-btn" @click="openBealter">
            <span>预约产品显示</span>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
// import value1 from '@/assets/personnelgrow/icon/value1.png';
// import value2 from '@/assets/personnelgrow/icon/value2.png';
// import value3 from '@/assets/personnelgrow/icon/value3.png';
// import value4 from '@/assets/personnelgrow/icon/value4.png';
// import stories1 from '@/assets/staffmanage/stories1.png';
// import stories2 from '@/assets/staffmanage/stories2.png';
// import stories3 from '@/assets/staffmanage/stories3.png';
// import stories4 from '@/assets/staffmanage/stories4.png';
// import stories5 from '@/assets/staffmanage/stories5.png';
// import stories6 from '@/assets/staffmanage/stories6.png';
// import stories7 from '@/assets/staffmanage/stories7.png';
export default {
  name: 'PersonnelGrow',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/personnelgrow/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      valueIndex: null,
      topNaviId: null,
      navList: [
        {
          title: '产品价值',
          id: 'product-value',
        },
        {
          title: '系统架构',
          id: 'architecture',
        },
        {
          title: '功能介绍',
          id: 'introduction',
        },
        {
          title: '数据安全',
          id: 'data-security',
        },
        {
          title: '客户案例',
          id: 'customer-stories',
        },
        {
          title: '资料下载',
          id: 'data-download',
        },
      ],
      valueList: [
        // {
        //   icon: value1,
        //   title: '建立知识体系',
        //   describe: '统筹管理企业各种类型课程包含文档、语音、视频、链接等根据业务需要建立讲师、培训机构、问卷调查等等基础数据',
        // },
        // {
        //   icon: value2,
        //   title: '管理制度托管',
        //   describe: '配备标准的三大培训体系流程满足企业业务发展的需要,根据个性化要求进行细节调整',
        // },
        // {
        //   icon: value3,
        //   title: '管理决策支撑',
        //   describe: '培训结果的重要体现，对企业人员进行在线考试的模式,实现对培训成果的考核，完善培训闭环中最后一个节点 ',
        // },
        // {
        //   icon: value4,
        //   title: '员工归属感',
        //   describe: '建立积分奖励机制和兑换平台激励员工自主提升个人能力和业务素养',
        // },
      ],
      architecture: '',
      introductionList: [
        // {
        //   img: require('@/assets/personnelgrow/introduction-img1.png'),
        //   title: '智能推送',
        //   subtitle: '多种薪酬制度如何在同一系统体现',
        //   ContentList: [
        //     '实施计划和课程与人员绑定，启动实施的同时系统自动推送信息给培训人员和讲师。',
        //     '培训体系的课程与岗位关联，人员上岗后能及时知晓必修课程。',
        //     '年度计划安排会根据参与培训的人员自动推送信息，方便员工合理安排时间培训。',
        //   ],
        // },
        // {
        //   img: require('@/assets/personnelgrow/introduction-img2.png'),
        //   title: '移动签到',
        //   subtitle: '手动签到耗时耗力，时候还需要登记培训记录',
        //   ContentList: [
        //     '使用二维码签到模式，签到后自动形成培训记录。',
        //     '培训开始时系统自动发消息提示参与培训人员进行签到。',
        //     '系统自动记录培训签到、签离时间，作为培训人员的学习课时。',
        //   ],
        // },
        // {
        //   img: require('@/assets/personnelgrow/introduction-img3.png'),
        //   title: '在线培训',
        //   subtitle: '集团化企业各个分支公司的相关岗位无法集中进行培训',
        //   ContentList: [
        //     '利用在线视频的培训方式，满足无法进行现场培训的要求。',
        //     '系统设置防呆模式，保证培训质量。',
        //     '直播培训，不限定在同一地点的同时，还能进行在线互动问答。',
        //   ],
        // },
        // {
        //   img: require('@/assets/personnelgrow/introduction-img4.png'),
        //   title: '在线考试',
        //   subtitle: '只有简单培训记录无法对培训成果进行考察  ',
        //   ContentList: [
        //     '建立自定义的考试平台，拥有企业自己内部的试题库。',
        //     '针对不同类型岗位的人员可以随机自动产生试卷。',
        //     '考试设置合格标准，设置补考模式，结果与岗位胜任关联。',
        //   ],
        // },
      ],
      introductionTagActiveIndex: 0,
      dataSecurityTagList: [
        // {
        //   title: '身份认证',
        //   url: require('@/assets/personnelgrow/icon/data-security-tag1.png'),
        //   index: 0,
        // },
        // {
        //   title: '安全访问',
        //   url: require('@/assets/personnelgrow/icon/data-security-tag2.png'),
        //   index: 1,
        // },
        // {
        //   title: '品质保证',
        //   url: require('@/assets/personnelgrow/icon/data-security-tag3.png'),
        //   index: 2,
        // },
      ],
      dataSecurityList: [
        // {
        //   url: require('@/assets/personnelgrow/data-security-img1.png'),
        //   textList: [
        //     '传统用户名/密码认证1',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
        // {
        //   url: require('@/assets/personnelgrow/data-security-img2.png'),
        //   textList: [
        //     '传统用户名/密码认证2',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
        // {
        //   url: require('@/assets/personnelgrow/data-security-img3.png'),
        //   textList: [
        //     '传统用户名/密码认证3',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
      ],
      dataSecurityTagActiveIndex: 0,
      enterpriseList: [
        // stories1,
        // stories2,
        // stories3,
        // stories4,
        // stories5,
        // stories6,
        // stories7,
        // stories1,
        // stories2,
        // stories3,
        // stories4,
        // stories5,
        // stories6,
        // stories7,
        // stories1,
        // stories2,
        // stories3,
        // stories4,
      ],
      dataDownloadList: [
        {
          title: '资料下载',
          dataList: [
            {
              id: 1,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 2,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 3,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
        {
          title: '产品动态',
          dataList: [
            {
              id: 4,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 5,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 6,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
        {
          title: '干货推荐',
          dataList: [
            {
              id: 7,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 8,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 9,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
      ],
    };
  },
  watch: {
    scrollTop(newValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
    this.getPartner();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = (offsetHeight / 2) + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    getPageColumn() {
      const params = { parentId: '1605835885893607424', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '产品价值') {
            const rrs = await getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, });
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              const valueItem = {
                icon: rrsult.data[j].icon,
                title: rrsult.data[j].title,
                describe: rrsult.data[j].description,
              };
              this.valueList.push(valueItem);
            }
          } else if (result[i].name === '系统架构') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              this.architecture = rrsult.icon;
            });
          } else if (result[i].name === '功能介绍') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var introductionItem = {
                  img: rrsult.data[j].icon,
                  title: rrsult.data[j].title,
                  subtitle: rrsult.data[j].summaryTitle,
                  ContentList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  introductionItem.ContentList.push(rtsult.elements[x].content);
                }
                this.introductionList.push(introductionItem);
              }
            });
          } else if (result[i].name === '数据安全') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var dataSecurityTag = {
                  title: rrsult.data[j].title,
                  url: rrsult.data[j].icon,
                  index: j,
                };
                this.dataSecurityTagList.push(dataSecurityTag);
                var rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var dataSecurityItem = {
                  url: rtsult.logo,
                  textList: [],
                };
                for (var x = 0; x < rtsult.elements.length; x++) {
                  dataSecurityItem.textList.push(rtsult.elements[x].content);
                }
                this.dataSecurityList.push(dataSecurityItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
      const downLoadParams = { columnId: '1605494229646401536', pageNum: 1, pageSize: 4, commendation: 13, cascade: true, };
      getContentList(downLoadParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[0].dataList = result.data;
      });
      const contentParams = { columnId: '1605774350588534784', pageNum: 1, pageSize: 4, commendation: 13, };
      getContentList(contentParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[1].dataList = result.data;
      });
      const industryParams = { columnId: '1605774444985540608', pageNum: 1, pageSize: 4, commendation: 13, };
      getContentList(industryParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[2].dataList = result.data;
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },

    clickDate(data, index) {
      if (index === 0) {
        getContentDetail(data.id).then((res) => {
          const { result, } = res;
          var file = result.elements.find(obj => obj.name === 'file').content;
          download(file[0].url).then((rrs) => {
            const fileName = file[0].name;
            const blob = new Blob([ rrs.data, ]);
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(fileName));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a');
              tempLink.style.display = 'block';
              tempLink.href = blobURL;
              tempLink.setAttribute('download', decodeURI(fileName));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
            }
          });
        });
      } else if (index === 1) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 1, }, });
      } else if (index === 2) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 2, }, });
      }
    },

    onMouseenter(i) {
      this.valueIndex = i;
    },
    onMouseleve() {
      this.valueIndex = null;
    },
    changeStep (index) {
      this.dataSecurityTagActiveIndex = index;
    },
    changeIntroduction (index) {
      this.introductionTagActiveIndex = index;
    },
    last () {
      if (this.dataSecurityTagActiveIndex !== 0) {
        this.dataSecurityTagActiveIndex -= 1;
      }
    },
    next () {
      if (this.dataSecurityTagActiveIndex !== 2) {
        this.dataSecurityTagActiveIndex += 1;
      }
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.personnel-grow{
  background-color: #fff;
  .page-content{
    width: 100%;
    .personnel-grow-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .personnel-grow-background{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        // width: 100%;
        // height: 560px;
        // // background-position: top;
        // // background-size: cover;
        // // background-repeat: no-repeat;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // object-fit: cover;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
          width: 85%;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          .solution-info {
            width: 540px;
            height: 560px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .solution-info-title {
              font-size: 45px;
              font-weight: bold;
              line-height: 55px;
              color: #181818;
              margin-bottom: 30px;
            }
            .solution-info-content {
              font-size: 20px;
              line-height: 32px;
              color: #7b7b7b;
              margin-bottom: 44px;
            }
            .solution-btn {
              width: 142px;
              height: 48px;
              background-color: #617fff;
              color: #fff;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
              border-radius: 24px;
            }
          }
        }
    }
    .personnel-grow-nav{
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .personnel-grow-nav-tabs{
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .personnel-grow-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .personnel-grow-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #ffffff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .product-value{
      width: 1200px;
      padding-top: 116px;
      margin: 0 auto;
      background-color: #fff;
      box-sizing: border-box;
      .title-subtitle{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 64px;
        .title{
          font-size: 32px;
          color: #181818;
          line-height: 1;
        }
        .subtitle{
          font-size: 16px;
          color: #7b7b7b;
          margin-top: 23px;
          line-height: 1;
        }
      }
      .value-list{
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 0 auto;
        .value-list-item{
          width: calc(50% - 30px);
          height: 187px;
          margin: 15px;
          background-color: #f5f5f5;
          .value-list-item-card{
            width: 100%;
            color: #181818;
            height: 100%;
            padding: 54px 36px 55px 40px;
            transition: all .3s ease-in-out;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            .list-item-icon-wrap{
              .list-item-icon{
                width: 54px;
                height: auto;
                opacity: 1;
                display: block;
              }
            }
            .list-item-text{
              margin-left: 40px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .list-item-title{
                font-size: 20px;
                line-height: 1;
                color: #181818;
              }
              .list-item-des{
                width: 100%;
                flex: 1;
                color: #757575;
                font-size: 16px;
                margin-top: 18px;
              }
            }
          }
        }
      }
    }
    .architecture{
      width: 1200px ;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .architecture-content{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .introduction{
      width: 1199px;
      padding-top: 109px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 70px;
        box-sizing: border-box;
      }
      .introduction-content{
        display: flex;
        align-items: flex-start;
        margin-top: 80px;
        width: 100%;
        height: 680px;
        .introduction-content-item{
          flex: 1;
          height: 100%;
          background-color: #fff;
          border-radius: 12px;
          border: solid 1px #ebf5ff;
          transition: all .5s ease-in-out;
          padding: 50px 26px 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          box-sizing: border-box;
          .introduction-tag-item-text{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            transition: all .5s ease-in-out;
            overflow: hidden;
            .introduction-tag-item-title{
              font-size: 24px;
              color: #181818;
              transition: all .5s ease-in-out;
            }
            .line{
              width: 32px;
              height: 6px;
              border-radius: 3px;
              background-color: #00b0dc;
              margin: 16px 0 18px;
            }
            .introduction-tag-item-subtitle{
              width: 128px;
              margin-top: 37px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              color: #7b7b7b;
              text-align: center;
              transition: all .5s ease-in-out;
            }
            .introduction-tag-item-content{
              width: 0px;
              overflow: hidden;
              transition: all .5s ease-in-out;
            }
          }
          .introduction-tag-item-img{
            width: 160px;
            height: 160px;
            position: absolute;
            top: 50%;
            margin-top: -60px;
            transition: all .5s ease-in-out;
            img{
              width: 100%;
              height: auto;
              transition: all .5s ease-in-out;
            }
          }
        }
        .introduction-tag-item-active{
          flex: 3;
          justify-content: space-between;
          padding: 50px 40px 60px;
          background-image: linear-gradient(-45deg,
            #eff4ff 0%,
            #f1fcfd 100%),
          linear-gradient(
            #eff4ff,
            #eff4ff);
            .introduction-tag-item-text{
              width: 100%;
              align-items: flex-start;
              .introduction-tag-item-title{
                font-weight: 500;
              }
              .introduction-tag-item-content{
                width: 520px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                .content-item{
                  width: 488px;
                  font-size: 16px;
                  color: #181818;
                  margin-top: 20px;
                  display: flex;
                  img{
                    width: 16px;
                    height: 12px;
                    margin-top: 5px;
                    margin-right: 12px;
                  }
                }
              }
            }
            .introduction-tag-item-img{
              width: 520px;
              height: 324px;
              position: static;
            }
        }
      }
    }
    .introduction-fade-enter-active {
      animation: bounce-in 1.3s;
    }
    .introduction-fade-leave-active {
      animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .data-security{
      width: 1200px;
      // min-width: var(--minwidth);
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        margin-bottom: 70px;
      }
      .data-security-tag{
        display: flex;
        align-items: center;
        margin-bottom: 60px;
        .data-security-tag-item{
          display: flex;
          align-items: center;
          cursor: pointer;
          .item-box{
            display: flex;
            flex-direction: column;
            align-items: center;
            .item-icon{
              width: 62px;
              height: 62px;
              background-color: transparent;
              border: 1px solid transparent;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 23px;
            }
            .item-icon-active{
              background-color: #fff;
              border: 1px solid #00b0dc;
              box-shadow: 0px 8px 20px 0px rgba(69, 125, 177, 0.12);
            }
            .item-title{
              font-size: 18px;
              color: #181818;
            }
          }
          .data-security-tag-arrow{
            width: 192px;
            height: 1px;
            background-color: #e1e6f0;
            margin: 0 28px;
            margin-bottom: 46px;
          }
        }
      }
      .data-security-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .arrow{
          width: 24px;
          height: 24px;
          box-shadow: 0px 8px 20px 0px rgba(75, 75, 137, 0.1);
          cursor: pointer;
          img{
            display: block;
          }
        }
        .data-security-content-list{
          height: 252px;
          display: flex;
          justify-content: center;
          align-items: center;
          .data-security-content-left{
            width: 355px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              display: block;
            }
          }
          .data-security-content-right{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            margin-left: 145px;
            .content-text-box{
              display: flex;
              justify-content: center;
              align-items: flex-start;
              .list-icon{
                width: 16px;
                height: 16px;
                margin-top: 1px;
                margin-right: 12px;
              }
              .text{
                font-size: 16px;
                color: #7b7b7b;
                line-height: 1;
                padding-bottom: 30px;
              }
            }
          }
        }
      }
      .secrity-fade-enter-active {
        animation: bounc-in 1.3s;
      }
      .secrity-fade-lave-active {
        animation: bounce-in .5s reverse;
      }
      @keyframes bounce-in {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 0;
        }
      }
    }
    .customer-stories{
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') center;
      background-size: cover;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 1200px;
        // min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #00b0dc;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
    .data-download{
      width: 70%;
      min-width: 1209px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 100px;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-download-content{
        display: flex;
        margin: 70px auto 0;
        .data-download-content-item{
          width: 386px;
          height: 250px;
          margin-right: 21px;
          padding: 31px 32px 0 28px;
          background: url('@/assets/staffmanage/download-back.png') center;
          background-size: cover;
          box-sizing: border-box;
          .dataListTitle{
            font-size: 18px;
            color: #181818;
            line-height: 1;
            margin-bottom: 14px;
          }
          .data-list{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .data-list-item{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 14px;
              // padding-left: 24px;
              box-sizing: border-box;
              list-style:disc;
              .data-list-left{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .disc{
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  background-color: #000;
                }
                .data-title{
                  width: 254px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  color: #181818;
                  cursor: pointer;
                  position: relative;
                  margin-left: 20px;
                }
              }
              .data-list-right{
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: auto;
                  height: 10px;
                  display: block;
                }
                display: none;
              }
            }
            .data-list-item:hover{
              .data-list-left{
                .disc{
                  background-color: #2979ff;
                }
                .data-title{
                  color: #2979ff;
                }
              }
              .data-list-right{
                display: block;
              }
            }
          }
        }
        .data-download-content-item:last-child{
          margin-right: 0;
        }
      }
    }
    .appointment-demonstration{
      width: 100%;
      height: 126px;
      background-image: url('@/assets/personnelgrow/appointment-demonstration.png');
      background-repeat: no-repeat;
      background-size: cover;
      color: #fff;
      // padding: 22px;
      box-sizing: border-box;
      .content-center{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .appointment-demonstration-text{
          .appointment-demonstration-title{
            font-size: 22px;
            color: #fff;
            font-weight: 500;
            margin-bottom: 16px;
            line-height: 1;
          }
          .appointment-demonstration-subtitle{
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            line-height: 1;
          }
        }
        .appointment-demonstration-btn{
          width: 124px;
          height: 42px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          border: 1px solid #fff;
          line-height: 42px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          // img{
          //   width: 18px;
          //   height: 42px;
          //   vertical-align: middle;
          // }
          transition: all 0.5s;
          // &:hover{
          //   transform: scale(1.1);
          //   transition: all  0.5s;
          // }
        }
      }
    }
  }
}
</style>
